import axios from "axios";
import React from "react";
import { Link, useParams } from "react-router-dom";
import Footer from "./Layout/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function Remove(props) {
  const params = useParams();
  const [Email, setEmail] = React.useState("");
  const [agree, setagree] = React.useState(false);
  const [description, setDescription] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [errors, setErrors] = React.useState([]);
  const submit = (e) => {
    e.preventDefault();
    if (Email == "") {
      toast.error("Email is required", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return false;
    }
    if (!agree) {
      toast.error("Agree to consent", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return false;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("email", Email);
    formData.append("description", description);
    axios
      .post("https://dashboard.maineautoparts.com/api/remove", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
        setErrors([]);
        setEmail("");
        setDescription("");
        toast.success("Request Sent!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        //// Run Job Schedule
        axios.get("https://dashboard.maineautoparts.com/api/run");
        setTimeout(function () {
          axios.get("https://dashboard.maineautoparts.com/api/run");
        }, 1000);
        setTimeout(function () {
          axios.get("https://dashboard.maineautoparts.com/api/run");
        }, 10000);
        //////////////////
      })
      .catch((error) => {
        toast.error("Error sending message", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
        setErrors(error.response.data.errors);
      });
  };
  React.useEffect(() => {
    setErrors([]);
  }, [params]);
  return (
    <>
      <ToastContainer />
      <div className="container mb-100 page">
        <div className="row">
          <div className="col-lg-2 sm-no">
            <img
              src="/image/face1.ee56825e.png"
              className="img-fluid face float-icons-2"
              alt="face1"
            />
            <img
              src="/image/face2.ffcfda88.png"
              className="img-fluid face2 float-icons-3"
              alt="face2"
            />
            <img
              src="/image/face3.968da958.png"
              className="img-fluid face3 float-icons"
              alt="face3"
            />
          </div>
          <div className="col-lg-8">
            <div className="card-sign-up text-center">
              <h3
                className="careers-mx"
                style={{ padding: 0, margin: 0, marginBottom: 15 }}
              >
                Delete Account?
              </h3>
              <h3 className="form-title h-25">
                We are sorry we have to let you go.
              </h3>
              <p
                className="mb-4"
                style={{ position: "relative", top: -18, textAlign: "center" }}
              >
                Please fill the form below to request deleting your user data
                collected over the period you used our app.
              </p>
              <form action="#" method="post">
                <input
                  name="email"
                  type="email"
                  className={[
                    "overide input-email ",
                    errors?.email ? " is-invalid" : "",
                  ]}
                  placeholder="Email address *"
                  value={Email}
                  onChange={(event) => setEmail(event.target.value)}
                />
                {errors?.email != undefined ? (
                  <p className="error">{errors?.email[0]}</p>
                ) : (
                  ""
                )}
                <textarea
                  name="description"
                  placeholder="Reason"
                  value={description}
                  className={`
                  overide text-text
                  ${errors?.description ? "is-invalid " : ""},
                `}
                  onChange={(event) => setDescription(event.target.value)}
                ></textarea>
                {errors?.description != undefined ? (
                  <p className="error">{errors?.description[0]}</p>
                ) : (
                  ""
                )}
                <div className="check">
                  <input
                    type="checkbox"
                    className="mf-input mf-checkbox-input "
                    onChange={() => setagree(!agree)}
                  />
                  <span>
                    I consent to the removal of ALL my data collected during the
                    period I had used this app and to the irreversibility of my
                    request.{" "}
                  </span>
                </div>
                <br></br>
                <br></br>
                <button type="submit" className="sign-up-btn" onClick={submit}>
                  Delete Account
                  <span
                    className="spinner-border spinner-border-sm onPageloader"
                    role="status"
                    aria-hidden="true"
                    style={{ display: loading ? "inline-block" : "none" }}
                  ></span>
                </button>
              </form>
            </div>
          </div>
          <div className="col-lg-2">
            <img
              src="/image/face4.5e4430b4.png"
              className="img-fluid face4 float-icons-3"
              alt="face4"
            />
            <img
              src="/image/face5.46fcb240.png"
              className="img-fluid face5 float-icons-2"
              alt="face5"
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Remove;
